const initialState ={
 isLoading: false,
 Details:"",
 vehicleDetails:"",
 razerpayupdate:"",

}
export default initialState;